export const AutentificacaoLogin = {
    // Letra A:
    // Letra B:
    // Letra C:
    // Letra D:
    // Letra E:
    EMAIL: 'Email',
    ESQUECEU_SENHA: "Did you forgot your password?",

    // Letra F:
    // Letra G:
    // Letra H:
    // Letra I:
    // Letra J:
    // Letra K:
    // Letra L:
    LOGIN: 'Login',

    // Letra M:
    // Letra N:
    // Letra O:
    // Letra P:
    // Letra Q:
    // Letra R:
    // Letra S:
    SENHA: 'Password',

    // Letra T:
    // Letra U:
    // Letra V:
    // Letra X:
    // Letra Y:
    // Letra Z:
}